export const partnersPage = {
  badge: "Partner invite",
  title: "Welcome from {{creator}}",
  lead: "{{creator}} partnered with Akinda so you can invest with clarity — screen stocks for Shariah compliance and build a portfolio that fits your values.",
  discountBadge: "{{percent}}% off annual plans",
  discountLabel: "off annual plans",
  cta: "Sign up free",
  loginHint: "Already have an account?",
  login: "Log in",
  sectionLabel: "Your partner offer",
  sectionTitle: "Claim {{percent}}% off with promo code {{code}}",
  sectionLead:
    "Create a free account, pick an annual plan when you’re ready, and enter the code at checkout.",
  benefits: {
    screening: "Halal stock screening",
    portfolio: "Portfolio tools",
    reports: "Shariah reports",
  },
  promoLabel: "Promo code",
  promoApplies: "Annual plans only",
  copyCode: "Copy",
  copied: "Copied",
  steps: {
    signup: "Sign up free",
    subscribe: "Choose an annual plan",
    code: "Enter {{code}} at checkout",
  },
  seo: {
    title: "{{creator}} invites you to Akinda — {{percent}}% off annual plans",
    description:
      "{{creator}} invited you to Akinda. Use promo code {{code}} for {{percent}}% off annual plans. Halal stock screening and Shariah-aligned investing.",
    keywords:
      "akinda partner, {{creator}}, promo code, annual plan discount, halal investing",
  },
} as const;
